import { Suspense, useRef, useState } from "react";
import { Button, Modal, Spin } from "antd";
import Logo from "@assets/logo-compressed.png";
import MillenniumLogo from "@assets/images/millenniumLogo.png";
import DemoLogo from "@assets/images/dashboardReport.png";
import envelop_png from "@assets/images/envelop_png.png";
import internet_png from "@assets/images/internet_png.png";
import membersService from "@services/members.service";
import { formatDisplayDate } from "@utils/helpers";
import CPSRNotes, { PhysicianCarePlan, RiskScore } from "./patientNotes/patientNotes";
import "./carePlanReport.scss";
import { isEmpty, map , noop, get} from "lodash";
import ProgramPage, { Referrals, TitleValue } from "./programPage/programPage";
// import { saveAs } from "file-saver";
import React from "react";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import moment from "moment";
import { CPSR_REPORT_UPLOAD_PROGRESS_DATA, dateFormatConfig } from "@utils/constants";
import { getClientName } from "@utils/helpers";
import { useFetchReferrals } from "./care-team-referrals/useReferrals";
import { useCarePlanReport } from "../../customHooks";
// import { InvoiceFooter } from "./footer";

const InvoiceFooter = React.lazy(() => import("./footer"));

const CarePlanReport = ({ payload , disableGenerateReportBtn = noop}: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReferralLoading , setisReferralLoading] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const {fetchReportData , carePlanReportData , referralData , carePlanProgramData , rules , isReportLoading , metaData} = useCarePlanReport();
  const {fetchReferrals} = useFetchReferrals();
  const ref: any = useRef(null);

  const showModal = () => {
    setIsModalOpen(true);
    fetchReportData({payload});

    if(get(payload , 'display.careTeamDetails' , true)) {
      fetchReferrals(setisReferralLoading);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button type="primary" onClick={showModal} disabled={disableGenerateReportBtn()}>
        Generate Report
      </Button>

      <Modal
        className="ui-care-plan-report-wrapper"
        title="Care Plan Report Summary"
        footer={
          <Suspense fallback={<div>Loading</div>}>
            <InvoiceFooter
              setIsDownloading={setIsDownloading}
              setIsUploading={setIsUploading}
              zoom={zoom}
              setZoom={setZoom}
              height={ref?.current?.clientHeight}
              metaData={metaData}
              programs={payload.programs}
            />
          </Suspense>
        }
        open={isModalOpen}
        onCancel={() => {
          if (!isDownloading) handleCancel();
        }}
        width={1000}
      >
        {(isReportLoading || isReferralLoading) ? (
          <div className="ui-care-plan-report--preloader">
            <div className="ui-care-plan-report--preloader--div1 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div2 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div1 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div2 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div1 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div2 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div1 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div2 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div1 shimmerBG"></div>
            <div className="ui-care-plan-report--preloader--div2 shimmerBG"></div>
          </div>
        ) : (
          <Spin
            spinning={isDownloading}
            indicator={
              <HealthemSpinner
                size={60}
                progressBarNeeded={true}
                progressData={[
                  { progress: 30, message: "Please Wait, creating care plan summary PDF." },
                  { progress: 60, message: "Please Wait, creating care plan summary PDF." },
                  { progress: 90, message: "Please Wait, creating care plan summary PDF." },
                ]}
                timeLimit={process.env.REACT_APP_HIGH_COST_PATIENT_BUILD_TIME_LIMIT ? Number(process.env.REACT_APP_HIGH_COST_PATIENT_BUILD_TIME_LIMIT) : 2000}
              />
            }
          >
            <Spin
              spinning={isUploading}
              indicator={
                <HealthemSpinner
                  size={60}
                  progressBarNeeded={true}
                  progressData={CPSR_REPORT_UPLOAD_PROGRESS_DATA}
                  timeLimit={10000}
                />
              }
            >   
               <CarePlanPdf {...({zoom, ref, payload, carePlanReportData, referralData, carePlanProgramData, rules})}/>
             
            </Spin>
          </Spin>
        )}
      </Modal>
    </>
  );
};

const Footer = ({hideSeparator} : any) => {
  return (
    <div className="ui-care-plan-report__footer">
      {hideSeparator ? null :<hr className="ui-care-plan-report__division"></hr>}
      <div className="ui-care-plan-report__footer__detail">
        <img src={Logo} alt="company logo" className="ui-care-plan-report__footer__detail__logo" />
        <div className="ui-care-plan-report__footer__detail__content">
          <div className="ui-care-plan-report__footer__detail__content__data">
            <div className="ui-care-plan-report__footer__detail__content__data__icon">
              {/* <Icon name={"envelope"} /> */}
              <img src={envelop_png} alt="company logo" />
            </div>
            <div className="ui-care-plan-report__footer__detail__content__data__value">support.healthem@tredence.com</div>
          </div>
          <div className="ui-care-plan-report__footer__detail__content__data">
            <div className="ui-care-plan-report__footer__detail__content__data__icon">
              {/* <Icon name={"internet"} colorOfBrand="#d15f25" /> */}
              <img src={internet_png} alt="company logo" />
            </div>
            <div className="ui-care-plan-report__footer__detail__content__data__value">https://www.healthem.ai</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Header = ({ headerDetails }: any) => {
  const clientName = getClientName();
  let headerLogo = clientName === 'Millennium' ? MillenniumLogo : DemoLogo;

  if (process.env.REACT_APP_ENVIRONMENT === "demo") {
    headerLogo = DemoLogo;
  }
  return (
    <div className="ui-care-plan-report__patient-info">
      <div className="ui-care-plan-report__patient-info__detail">
        <img src={headerLogo} alt="company logo" className="ui-care-plan-report__patient-info__detail__logo" />
        <div className="ui-care-plan-report__patient-info__detail__content">
          <div>
            <div className="ui-care-plan-report__patient-info__detail__content__data__label">Patient Name</div>
            <div className={`ui-care-plan-report__patient-info__detail__content__data__value`}>{headerDetails?.patientName}</div>
          </div>
          <div>
            <div className="ui-care-plan-report__patient-info__detail__content__data__label">Record ID</div>
            <div className={`ui-care-plan-report__patient-info__detail__content__data__value`}>{headerDetails?.recordId}</div>
          </div>
        </div>
      </div>
      {/* <hr className="ui-care-plan-report__division ui-care-plan-report__header-division"></hr> */}
    </div>
  );
};

export function CarePlanPdf({ zoom, ref, payload, carePlanReportData, referralData, carePlanProgramData, rules }: any) {
  return (
    <div className="ui-care-plan-report--wrapper custom-scroll-bar">
      <div className="ui-care-plan-report" style={{ zoom: zoom }}>
        {(get(payload, "display.patientDetails", true) || get(payload, "display.careTeamDetails", true) || get(payload, "display.riskScore", true)) && (
          <>
            <Header headerDetails={carePlanReportData?.headerDetails} />
            <div className="ui-care-plan-report__page" ref={ref}>
              <div className="ui-care-plan-report__title">
                <div className="ui-care-plan-report__title__text">Care Plan Report </div>
                <span className="date">{moment(new Date()).format(dateFormatConfig.get(getClientName())["defaultDateFormat"])}</span>
              </div>
              <hr className="ui-care-plan-report__division"></hr>
              {get(payload, "display.patientDetails", true) ? <TitleValue data={carePlanReportData?.patientDetails} heading="Patient Details" /> : <></>}
              {!isEmpty(referralData) && get(payload, "display.careTeamDetails", true) ? <Referrals data={referralData} heading="Care Team Details" /> : <></>}
              {get(payload, "display.riskScore", true) ? <RiskScore data={carePlanReportData?.riskScore} /> : <></>}
              {carePlanReportData?.physicianCarePlan ? <PhysicianCarePlan data={carePlanReportData?.physicianCarePlan} notesPayload={payload?.physicianCarePlanNotes} /> : null}
              {carePlanReportData?.patientLevelNotes ? <CPSRNotes data={carePlanReportData?.patientLevelNotes} height={ref?.current?.clientHeight} /> : null}
            </div>
            <Footer hideSeparator={true} />
          </>
        )}
        {map(carePlanProgramData, (item, index) => {
          return (
            <>
              <Header headerDetails={carePlanReportData?.headerDetails} key={`header${index}`} />
              <div className="ui-care-plan-report__page" key={`body${index}`}>
                <div className="ui-care-plan-report__title">
                  <div className="ui-care-plan-report__title__left-container">
                    <span className="ui-care-plan-report__title__left-container__program-title">{item.headerDetails?.planName}</span>
                    <span className="ui-care-plan-report__title__left-container__date">
                      {`(${formatDisplayDate(item.headerDetails?.fromDate, "reminderDateActualFormat", "defaultDateFormat")}
                      to
                      ${formatDisplayDate(item.headerDetails?.toDate, "reminderDateActualFormat", "defaultDateFormat")})`}
                    </span>
                  </div>
                  <div className="ui-care-plan-report__title__right-container">
                    <span className="ui-care-plan-report__title__right-container__designation">{item?.careTeam?.designation}:</span>
                    <span className="ui-care-plan-report__title__right-container__name">{item?.careTeam?.name}</span>
                  </div>
                </div>
                <hr className="ui-care-plan-report__division"></hr>
                <ProgramPage data={item} rules={rules} />
              </div>
              <Footer hideSeparator={false} key={`footer${index}`} />
            </>
          );
        })}
      </div>
    </div>
  );
}

export default CarePlanReport;
